export enum AllPermissionsKeys {
    HomePage = '1',
    UserManagement = '2',
    Setting = '3',
    Reports= '4',
    BulkUpload = '5',
    Sessions = '6',
    ExportedReports = '7',
    Marketplace = '8',
    Statistics = '9',
    SendMsg = '10',
    Fatiha = '11',
}